module.exports = __webpack_public_path__ + "img/problem-top-bg.b021a035.png";